module.exports = __webpack_public_path__ + "static/media/guide.df6e4a92.png";